import { css } from 'styled-components';
import { CFBaseLinkTokens } from '..';
import { CFTokens } from '../../../../tokens';
export const rootHover = ({ variant = 'primary' }) => {
    return css `
    &:hover {
      color: ${CFBaseLinkTokens.COLOR.HOVER[variant]};
    }
  `;
};
export const rootStyles = ({ disabled, variant = 'primary', weight = 'semibold', }) => {
    if (disabled) {
        return css `
      color: ${CFBaseLinkTokens.COLOR.TEXT['disabled']};
      font-family: ${CFTokens.FONT_FAMILY.ARCHIVO[weight.toUpperCase()]};
      pointer-events: none;
    `;
    }
    return css `
    color: ${CFBaseLinkTokens.COLOR.TEXT[variant]};
    font-family: ${CFTokens.FONT_FAMILY.ARCHIVO[weight.toUpperCase()]};
  `;
};
